/**
 * @typedef {number} ContestRewardStatus
 */

export const CONTEST_REWARD_STATUS__PENDING = 0;
export const CONTEST_REWARD_STATUS__CLAIMED = 1;

/**
 * @param {ContestRewardStatus} status
 * @returns {?string}
 */
export function getContestRewardStatusStr(status) {
  switch(status) {
    case CONTEST_REWARD_STATUS__PENDING: return 'ожидание';
    case CONTEST_REWARD_STATUS__CLAIMED: return 'получен';
  }

  return null;
}
